app.service('message', function (modal, loading) {

	function get(data) {
		let url = '/message-alert.ltr';
		if (!data) {
			reject();
		}
		if (typeof data === 'string') {
			data = {
				code: data
			}
		} else if (typeof data === 'object') {
			if(data.url) {
				url = data.url;
			}
		}
		return new Promise(function (resolve, reject) {
			$.ajax({
				url: url,
				data: data,
				success: function (html) {
					resolve(html);
				},
				error: function () {
					modal.alert('Błąd pobierania komunikatu');
					reject();
				}
			});
		});
	}
	function alert(data, callback) {
		loading.start();
		get(data).then(function (text) {
			loading.stop();
			modal.alert(text, callback);
		});
	}

	return {
		get, alert
	};
});
